import React from "react"
import PropTypes from "prop-types"
import { Background } from "react-imgix"

import networkDark from "../images/overview/network.svg"
import monitoringDark from "../images/overview/monitoring.svg"
import installDark from "../images/overview/install.svg"
import appDark from "../images/overview/app.svg"


class GenericHero extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      network: networkDark,
      monitoring: monitoringDark,
      install: installDark,
      app: appDark,
    }
  }

  render() {
    const { children, image, overlay, imgixParams } = this.props
    const { network, monitoring, install, app } = this.state
    return (
      <div className="generic-hero">
        <Background
          src={image}
          className="generic-hero__header"
          imgixParams={imgixParams}
        >
          {overlay ? <div className="generic-hero__overlay" /> : null}
          <h1 className="generic-hero__text">{children}</h1>
        </Background>
        <div className="generic-hero__features">
          <div className="feature">
            <img
              className="feature__icon"
              src={network}
              alt="Reliable Network"
            />
            <div className="feature__desc t2">Reliable Network</div>
          </div>
          <div className="feature">
            <img
              className="feature__icon"
              src={monitoring}
              alt="Professional Monitoring"
            />
            <div className="feature__desc t2">24/7 Professional Monitoring</div>
          </div>
          <div className="feature">
            <img
              className="feature__icon"
              src={install}
              alt="Installation Your Way"
            />
            <div className="feature__desc t2">Installation Your Way</div>
          </div>
          <div className="feature">
            <img className="feature__icon" src={app} alt="All In One App" />
            <div className="feature__desc t2">All In One App</div>
          </div>
        </div>
      </div>
    )
  }
}

GenericHero.propTypes = {
  children: PropTypes.node.isRequired,
  image: PropTypes.string.isRequired,
  overlay: PropTypes.bool,
  imgixParams: PropTypes.instanceOf(Object),
}

GenericHero.defaultProps = {
  overlay: false,
  imgixParams: { w: 1280, fit: "crop" },
}

export default GenericHero
